module.exports = __webpack_public_path__ + "img/leftMenuClick.a0be688a.png";